<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Sucursales`,
          link: 'companies',
        },
        {
          text: company.id ? company.name : 'Nueva sucursal',
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-3">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <!-- NOMBRE -->
            <div class="form-group">
              <label>Nombre</label>
              <input
                type="text"
                v-model="company.name"
                :class="`form-control ${errors.name ? 'is-invalid' : ''}`"
              />
            </div>

            <!-- NOMBRE CORTO -->
            <div class="form-group">
              <label>Nombre corto</label>
              <input
                type="text"
                v-model="company.short_name"
                :class="`form-control ${errors.short_name ? 'is-invalid' : ''}`"
              />
            </div>

            <!-- TIPO -->
            <!-- <div class="form-group">
              <label>Tipo comercio</label>
              <select
                v-model="company.type"
                :class="`form-control ${errors.type ? 'is-invalid' : ''}`"
              >
                <option value="">-Seleccione-</option>
                <option v-for="t in companyTypes" :value="t.id" :key="t.id">
                  {{ t.name }}
                </option>
              </select>
            </div> -->

            <!-- ESTADO -->
            <div class="form-group">
              <label>Estado</label>
              <select
                v-model="company.status"
                :class="`form-control ${errors.status ? 'is-invalid' : ''}`"
              >
                <option value="1">Activo</option>
                <option value="0">Inactivo</option>
              </select>
            </div>
            <!-- MINIMO DE COMPRA -->
            <!-- <div class="row"> -->
            <!-- <div class="col-6">
                
                <div class="form-group">
                  <label>Mínimo de compra</label>
                  <input
                    type="number"
                    min="1"
                    max="99999"
                    v-model="company.minimum"
                    :class="`form-control ${
                      errors.minimum ? 'is-invalid' : ''
                    }`"
                  />
                </div>
              </div> -->
            <!-- COSTO ENVIO -->
            <!-- <div class="col-6">
                
                <div class="form-group">
                  <label>Costo de envío</label>
                  <input
                    type="number"
                    min="1"
                    max="99999"
                    v-model="company.shipping_cost"
                    :class="`form-control ${
                      errors.shipping_cost ? 'is-invalid' : ''
                    }`"
                  />
                </div>
              </div> -->
            <!-- </div> -->

            <!-- <div class="row"> -->
            <!-- TOTAL DE ORDENES -->
            <!-- <div class="col-sm-6">
            
                <div class="form-group">
                  <label>Total de ordenes</label>
                  <input
                    type="number"
                    min="1"
                    max="99999"
                    v-model="company.total_orders"
                    :class="`form-control ${
                      errors.total_orders ? 'is-invalid' : ''
                    }`"
                  />
                </div>
              </div> -->
            <!-- TASA CONVERSION -->
            <!-- <div class="col-sm-6">
               
                <div class="form-group">
                  <label>Tasa conversión</label>
                  <input
                    type="number"
                    min="1"
                    max="99999"
                    v-model="company.convertion_rate"
                    :class="`form-control ${
                      errors.convertion_rate ? 'is-invalid' : ''
                    }`"
                  />
                </div>
              </div> -->
            <!-- </div> -->
            <!-- ORDEN EN EL APP MOVIL (position) -->
            <!-- <div class="row">
              <div class="col-sm-6">
                
                <div class="form-group">
                  <label>Orden de lista</label>
                  <input
                    type="number"
                    min="1"
                    max="99999"
                    v-model="company.position"
                    :class="`form-control ${
                      errors.position ? 'is-invalid' : ''
                    }`"
                  />
                </div>
              </div>
            </div> -->

            <!-- HAS PICKUP -->
            <!-- <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label for="accept_pickup">Acepta pickup</label>
                  <br />
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="company.accept_pickup"
                      name="accept_pickup"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            </div> -->

            <!-- HAS DELIVERY -->
            <!-- <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label for="accept_delivery">Acepta delivery</label>
                  <br />
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="company.accept_delivery"
                      name="accept_delivery"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            </div> -->

            <!-- HAS API -->
            <!-- <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label for="hasApi">Modulo API</label>
                  <br />
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="company.api_enabled"
                      name="hasApi"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            </div> -->
          </div>
          <div class="col-sm-6">
            <!-- DIRECCION -->
            <div class="form-group">
              <label>Seleccione provincias</label>
              <ul class="list-group user-companies-list">
                <li
                  v-for="c in provinces"
                  @click="selectProvince(c)"
                  :value="c.id"
                  :class="
                    c.selected
                      ? 'list-group-item bg-success'
                      : 'list-group-item'
                  "
                  :key="c.id"
                >
                  {{ c.name }}
                </li>
              </ul>
            </div>

            <!-- LATITUD -->
            <div class="form-group">
              <label>Zona compania</label>
              <input
                type="text"
                v-model="company.zoneCompany"
                :class="`form-control `"
              />
            </div>

            <!-- FOTO -->
            <div class="text-center">
              <ImageSelectBtn
                id="COMPANY_PHOTO"
                :uploading="uploadingPhoto"
                :label="'Foto ' + (photoProgress ? `${photoProgress}%` : '')"
                v-on:file-selected="setCompanyPhoto"
              />
              <br />
              <div class="form-group">
                <img
                  :src="photoPreviewCompany"
                  v-show="photoPreviewCompany != ''"
                  alt="Foto"
                  id="photoPreviewCompany"
                  class="photo-preview"
                />
              </div>
            </div>

            <!-- FONDO -->
            <div class="text-center">
              <ImageSelectBtn
                id="COMPANY_BG"
                :uploading="uploadingBg"
                :label="
                  'Imagen de fondo ' +
                  (bgPhotoProgress ? `${bgPhotoProgress}%` : '')
                "
                v-on:file-selected="setCompanyBg"
              />
              <br />
              <div class="form-group">
                <img
                  :src="photoPreviewCompanyBg"
                  v-show="photoPreviewCompanyBg != ''"
                  alt="Foto de fondo"
                  id="photoPreviewCompanyBg"
                  class="photo-preview"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12 text-right">
            <button
              :disabled="saving"
              class="btn main-green-bg"
              @click="saveCompany"
            >
              <span v-if="saving">Espere</span>
              <span v-else>
                <i class="fa fa-save"></i>
                Guardar cambios
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageSelectBtn from "../components/ImageSelectBtn";
import Breadcrumbs from "../components/Breadcrumbs";
import { CompanyService } from "../../services/CompanyService";
import Loader from "../components/Loader";
import PhotoUploader from "../../commons/PhotoUploader";

export default {
  name: "CompanyDetail",
  components: {
    ImageSelectBtn,
    Breadcrumbs,
    Loader,
  },
  data: function () {
    return {
      company: {
        id: "",
        name: "",
        short_name: "",
        status: this.$constants.companyStatus.ACTIVE,
        photo: "",
        photo_ref: "",
        zoneCompany: "",
        province: "",
        background_photo: "",
      },
      photoFileCompany: null,
      photoFileCompanyBg: null,
      photoPreviewCompany: "",
      photoPreviewCompanyBg: "",
      loading: false,
      photoPreview: "",
      defaultPhotoPreview: "../../assets/no_image.png",
      companyTypes: [],
      companyService: new CompanyService(),
      photoProgress: "",
      bgPhotoProgress: "",
      errors: {
        name: false,
        short_name: false,
        status: false,
        address: false,
        type: false,
        minimum: false,
        shipping_cost: false,
        latitude: false,
        longitude: false,
        total_orders: false,
        convertion_rate: false,
        position: false,
      },
      uploadingPhoto: false,
      uploadingBg: false,
      saving: false,
      provinces: [],
    };
  },
  methods: {
    selectProvince(item) {
      item.selected = !item.selected;
      var itemIndex = inventory.findIndex((x) => x.id == item.id);

      this.provinces[itemIndex] = {
        ...inventory[itemIndex],
        selected: item.select,
      };
    },
    validateFields() {
      if (this.company.name.length < 3) {
        this.$helpers.toast(
          "Nombre debe ser mayor que 3 caracteres",
          "warning"
        );
        this.errors.name = true;
        return false;
      }
      this.errors.name = false;

      if (this.company.short_name.length < 3) {
        this.$helpers.toast(
          "Nombre corto debe ser mayor que 3 caracteres",
          "warning"
        );
        this.errors.short_name = true;
        return false;
      }
      this.errors.short_name = false;

      // if (this.company.type === '') {
      //   this.errors.type = true;
      //   this.$helpers.toast("El estado es obligatorio", "warning");
      //   return false;
      // }
      // this.errors.type = false;

      if (this.company.status === "") {
        this.errors.status = true;
        this.$helpers.toast("El estado es obligatorio", "warning");
        return false;
      }
      this.errors.status = false;

      return true;
    },

    cleanAllFields: function () {
      this.company = {
        id: "",
        name: "",
        status: this.$constants.companyStatus.ACTIVE,
        currency: "",
        photo: "",
        photo_ref: "",
        location: {
          latitude: "",
          longitude: "",
        },
        address: "",
        short_name: "",
        api_enabled: false,
      };
      this.photoFileCompany = null;
      this.photoFileCompanyBg = null;
      this.photoPreviewCompany = "";
      this.photoPreviewCompanyBg = "";

      $("#photoPreviewCompany").attr("src", "/assets/no_image.png");
      $("#photoFileCompany").val("");

      $("#photoPreviewCompanyBg").attr("src", "/assets/no_image.png");
      $("#photoFileCompanyBg").val("");
    },
    isValidImage: function (file) {
      if (typeof file !== "object") {
        return false;
      }
      if (this.$constants.VALID_IMG_TYPES.indexOf(file.type) === -1) {
        return false;
      }
      if (file.size > this.$constants.ONE_MEGABYTE) {
        this.$helpers.toast("La imagen es muy grande (>1mb)", "warning");
        return false;
      }
      return true;
    },
    openCompanyModal: function () {
      $("#suplier-modal").modal({
        backdrop: false,
        keyboard: false,
      });
    },
    async setCompanyPhoto(data) {
      this.saving = true;
      this.photoFileCompany = data.file;
      this.photoPreviewCompany = data.preview;
      this.company.photo = data.preview;
      const idRef = this.company.id ? this.company.id : `NUEVA_${Date.now()}`;
      const imaege = await PhotoUploader.upload(
        "BranchOffices",
        idRef,
        data.file,
        (progress) => {
          this.photoProgress = progress;
        }
      );
      this.photoProgress = "";
      this.company.photo = imaege.url;
      this.saving = false;
    },
    async setCompanyBg(data) {
      this.saving = true;
      this.photoFileCompanyBg = data.file;
      this.photoPreviewCompanyBg = data.preview;
      this.company.background_photo = data.preview;
      const idRef = this.company.id
        ? this.company.id
        : `BG_NUEVA_${Date.now()}`;
      const image = await PhotoUploader.upload(
        "BranchOfficesBG",
        idRef,
        data.file,
        (progress) => {
          this.bgPhotoProgress = progress;
        }
      );
      this.bgPhotoProgress = "";
      this.company.background_photo = image.url;
      this.saving = false;
    },
    saveCompany: async function () {
      if (this.$route.params.company_id != 0) {
        this.updateCompanyMethod();
        return;
      }
      if (!this.validateFields()) return false;

      if (this.photoFile) {
        const photoUpload = await PhotoUploader.upload(
          "Companies",
          this.company.id,
          this.photoFile
        );
        this.company.photo = photoUpload.url;
        this.company.photo_ref = photoUpload.fileNameRef;
      }

      this.saving = true;
      try {
        let res = null;

        const ids = Array.from(new Set(this.selectedProvince.map((x) => x.id)));
        const names = Array.from(
          new Set(this.selectedProvince.map((x) => x.name))
        );

        var data = {
          Name: this.company.name,
          ShortName: this.company.short_name,
          CompanyId: this.company.short_name + "@domi.com",
          Province: names.toString(),
          IdProvinces: ids.toString(),
          Status: this.company.status,
          ZoneCompany: this.company.zoneCompany,
          Photo: this.company.photo,
          BackgroundPhoto: this.company.background_photo,
        };

        res = await this.companyService.addCompany(data);

        if (res.ok) {
          this.$helpers.message("Bien", "Datos guardados.");
          this.$router.push("/companies");
        } else {
          this.$helpers.message("Oops", res.message, "error");
        }
      } catch (error) {
        this.$helpers.message("Oops", "Algo salio mal", "error");
        console.log(error);
      }
      this.saving = false;
    },
    async getProvincesData() {
      try {
        this.loading = true;
        const res = await this.companyService.getProvinces();
        res.data.forEach((element) => {
          element.selected = false;
          this.provinces.push(element);
        });

        this.loading = false;
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },
    async updateCompanyMethod() {
      try {
        let res = null;
        const ids = Array.from(new Set(this.selectedProvince.map((x) => x.id)));
        const names = Array.from(
          new Set(this.selectedProvince.map((x) => x.name))
        );
        var data = {
          Id: this.company.id,
          Name: this.company.name,
          ShortName: this.company.short_name,
          Province: names.toString(),
          IdProvinces: ids.toString(),
          Status: this.company.status,
          ZoneCompany: this.company.zoneCompany,
          Photo: this.company.photo,
          BackgroundPhoto: this.company.background_photo,
        };
        res = await this.companyService.updateCompany(data);

        if (res.ok) {
          this.$helpers.message("Bien", "Datos guardados.");
          this.$router.push("/companies");
        } else {
          this.$helpers.message("Oops", res.message, "error");
        }
        this.loading = true;
        this.loading = false;
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },
    async getCompanyByIdLocal() {
      try {
        this.loading = true;
        var provincesLocal = [];
        const res = await this.companyService.getCompanyByID(
          this.$route.params.company_id
        );
        this.company.id = res.data.Id;
        this.company.name = res.data.Name;
        this.company.short_name = res.data.ShortName;
        this.company.zoneCompany = res.data.ZoneCompany;
        this.company.status = res.data.Status;
        this.company.background_photo = res.data.BackgroundPhoto;
        this.company.photo = res.data.Photo;
        this.photoPreviewCompany = res.data.Photo;
        this.photoPreviewCompanyBg = res.data.BackgroundPhoto;

        var provinceArr = res.data.Province.split(",");
        this.provinces.forEach((elem) => {
          provinceArr.forEach((p) => {
            if (elem.name == p) {
              elem.selected = true;
            }
          });
          provincesLocal.push(elem);
        });
        this.provinces = provincesLocal;
        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
        this.loading = false;
      }
    },
  },
  watch: {
    "company.photo": function (value) {
      if (value) {
        this.photoPreview = value;
      }
    },
  },
  mounted: async function () {
    await this.getProvincesData();
    if (this.$route.params.company_id != 0) {
      this.getCompanyByIdLocal();
    }
  },
  computed: {
    selectedProvince() {
      return this.provinces.filter((x) => x.selected);
    },
  },
};
</script>
<style scoped>
.photo-preview {
  height: 140px;
}
.list-group {
  max-height: 200px;
  margin-bottom: 10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
